import React from 'react';
import { DollarSign } from 'lucide-react';
export function IncomePotential() {
  return <section className="py-20 px-4 bg-black text-white" data-id="element-121">
      <div className="max-w-4xl mx-auto text-center" data-id="element-122">
        <h2 className="text-3xl md:text-5xl font-black mb-12 text-amber-500" data-id="element-123">
          💰 ¿Se puede ganar dinero con pisos epoxi en Argentina?
        </h2>

        <div className="space-y-8 text-xl md:text-2xl font-light leading-relaxed" data-id="element-124">
          <p data-id="element-125">Un solo trabajo pequeño puede cubrir varias veces la inversión.</p>

          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8 my-8 font-bold text-white" data-id="element-126">
            <div className="bg-[#1a1a1a] p-4 rounded-lg border border-amber-900/40" data-id="element-127">
              Una casa.
            </div>
            <div className="bg-[#1a1a1a] p-4 rounded-lg border border-amber-900/40" data-id="element-128">
              Una cochera.
            </div>
            <div className="bg-[#1a1a1a] p-4 rounded-lg border border-amber-900/40" data-id="element-129">
              Un depósito chico.
            </div>
            <div className="bg-[#1a1a1a] p-4 rounded-lg border border-amber-900/40" data-id="element-130">
              Un local.
            </div>
          </div>

          <p className="text-gray-300" data-id="element-131">El mercado está en expansión.</p>

          <p className="text-gray-300" data-id="element-132">
            La inversión es menor que muchos gastos mensuales.
          </p>

          <div className="mt-12 p-8 border-2 border-amber-600 rounded-2xl bg-amber-900/10" data-id="element-133">
            <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-134">
              Pero el conocimiento puede generarte ingresos durante años.
            </p>
          </div>
        </div>
      </div>
    </section>;
}